export const ACCOUNT_PLATFORM_TOASTS = {
  NO_PLATFORM_ERROR_OCCURRED: 'This account currently does not have a valid platform to create ads for.',
  UPDATED_AUDIENCE: 'Customer file successfully updated.',
  EDIT_DENIED: 'You do not have permission to edit this account platform',
  ACCOUNT_PLATFORM_UPDATED: 'Account platform successfully updated',
  DUPLICATE_PLATFORM_NAME_ERROR: 'Platform name already exists',
  ACCOUNT_PLATFORM_DELETED: 'Account platform successfully deleted',
  CONFIGURATION_UPDATE_SUCCESS: 'Settings have been successfully overwritten',
};
